import { useMemo } from 'react';
import NarrativeTypes from '~/constants/vdp/narrativeTypes';
import { useConfiguration } from '~/context/common/StaticContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import { Narrative } from '~/contracts/vdp/Narratives';

export default function useGetVaultWhyBuyNarrative(): Narrative {
  const {
    VaultWhyBuyNarrativeConfig: {
      bucket: { control = '', treatment = '' } = {}
    } = {}
  } = useConfiguration();
  const { narratives } = useGetVehicleDetails();

  return useMemo(() => {
    if (!narratives) return {};

    const findNarrative = (version: string) =>
      version
        ? narratives.find(
            n =>
              n?.narrativeType === NarrativeTypes.VIN_WHY_BUY &&
              n?.narrativeVersion === version
          )
        : undefined;

    return findNarrative(treatment) ?? findNarrative(control) ?? {};
  }, [control, narratives, treatment]);
}
